import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer bg-black small text-center text-light" }
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = { class: "text-light text-opacity-75" }
const _hoisted_4 = { class: "container col-12 col-lg-4 col-md-6" }
const _hoisted_5 = { class: "col text-center" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AgbComponent = _resolveComponent("AgbComponent")!
  const _component_CitesComponent = _resolveComponent("CitesComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, " copyright © ironwood flutes " + _toDisplayString($options.copyrightYears), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/impressum",
                class: "link-light fw-bold link-opacity-75 text-decoration-none"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("legal notice", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/datenschutz",
                class: "link-light fw-bold link-opacity-75 text-decoration-none"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("privacy policy", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("a", {
                role: "button",
                tabindex: "0",
                class: "link-light fw-bold link-opacity-75 text-decoration-none",
                style: {"cursor":"pointer"},
                "data-bs-toggle": "modal",
                "data-bs-target": "#citesModal"
              }, "cites")
            ], -1))
          ])
        ])
      ])
    ]),
    _createVNode(_component_AgbComponent),
    _createVNode(_component_CitesComponent)
  ], 64))
}